/* Event Categories */
export var BOOKING_EVENT_CATEGORY = 'Booking';
export var SERVICES_EVENT_CATEGORY = 'Services';
export var ABOUT_EVENT_CATEGORY = 'About';
export var PRODUCTS_EVENT_CATEGORY = 'Products';
export var REVIEWS_EVENT_CATEGORY = 'Reviews';
export var TEAM_EVENT_CATEGORY = 'Team';
export var GALLERY_EVENT_CATEGORY = 'Gallery';
export var BLOG_EVENT_CATEGORY = 'Blog';
export var CONTACT_EVENT_CATEGORY = 'Contact';
export var LOCATION_EVENT_CATEGORY = 'Location';
export var NAVIGATION_EVENT_CATEGORY = 'Navigation';
export var MARKDOWN_LINK_EVENT_CATEGORY = 'MarkdownLink';
export var FOOTER_EVENT_CATEGORY = 'Footer';
export var ANNOUNCEMENT_EVENT_CATEGORY = 'Announcement';
export var NEWSLETTER_EVENT_CATEGORY = 'Newsletter';
export var SOCIAL_EVENT_CATEGORY = 'Social';
export var CAROUSEL_EVENT_CATEGORY = 'Carousel';
export var PAGINATED_GRID_EVENT_CATEGORY = 'PaginatedGrid';
export var HOURS_OF_OPERATION_EVENT_CATEGORY = 'HoursOfOperation';
export var HERO_EVENT_CATEGORY = 'Hero';
export var EVENT_CATEGORIES = {
  BOOKING_EVENT_CATEGORY: BOOKING_EVENT_CATEGORY,
  SERVICES_EVENT_CATEGORY: SERVICES_EVENT_CATEGORY,
  PRODUCTS_EVENT_CATEGORY: PRODUCTS_EVENT_CATEGORY,
  REVIEWS_EVENT_CATEGORY: REVIEWS_EVENT_CATEGORY,
  TEAM_EVENT_CATEGORY: TEAM_EVENT_CATEGORY,
  GALLERY_EVENT_CATEGORY: GALLERY_EVENT_CATEGORY,
  BLOG_EVENT_CATEGORY: BLOG_EVENT_CATEGORY,
  CONTACT_EVENT_CATEGORY: CONTACT_EVENT_CATEGORY,
  LOCATION_EVENT_CATEGORY: LOCATION_EVENT_CATEGORY,
  NAVIGATION_EVENT_CATEGORY: NAVIGATION_EVENT_CATEGORY,
  FOOTER_EVENT_CATEGORY: FOOTER_EVENT_CATEGORY,
  ANNOUNCEMENT_EVENT_CATEGORY: ANNOUNCEMENT_EVENT_CATEGORY,
  NEWSLETTER_EVENT_CATEGORY: NEWSLETTER_EVENT_CATEGORY,
  SOCIAL_EVENT_CATEGORY: SOCIAL_EVENT_CATEGORY,
  CAROUSEL_EVENT_CATEGORY: CAROUSEL_EVENT_CATEGORY,
  PAGINATED_GRID_EVENT_CATEGORY: PAGINATED_GRID_EVENT_CATEGORY,
  HOURS_OF_OPERATION_EVENT_CATEGORY: HOURS_OF_OPERATION_EVENT_CATEGORY,
  ABOUT_EVENT_CATEGORY: ABOUT_EVENT_CATEGORY,
  HERO_EVENT_CATEGORY: HERO_EVENT_CATEGORY
};

/* Event Actions */
// Booking
export var BOOKING_SCHEDULE_APPOINTMENT_EVENT_ACTION = 'Schedule Appointment';
export var BOOKING_SCHEDULE_APPOINTMENT_INTENT_EVENT_ACTION = 'Schedule Appointment Intent';
export var BOOKING_CANCEL_APPOINTMENT_EVENT_ACTION = 'Cancel Appointment';

// Services
export var SERVICES_VIEW_CATEGORY_DETAILS_EVENT_ACTION = 'View Category Details';
export var SERVICES_VIEW_ITEM_DETAILS_EVENT_ACTION = 'View Item Details';
export var SERVICES_VIEW_ALL_SERVICES_EVENT_ACTION = 'View All Services';
export var SERVICES_SHARE_ITEM_EVENT_ACTION = 'Share Service Item';
export var SERVICES_LIKE_ITEM_EVENT_ACTION = 'Like Service Item';
export var SERVICES_CATEGORY_INTERACTION_ACTION = 'Category Interaction';
export var SERVICES_ITEM_INTERACTION_ACTION = 'Item Interaction';

// Products
export var PRODUCTS_ADD_TO_CART_EVENT_ACTION = 'Add to Cart';
export var PRODUCTS_REMOVE_FROM_CART_EVENT_ACTION = 'Remove from Cart';
export var PRODUCTS_VIEW_PRODUCT_EVENT_ACTION = 'View Product';

// Testimonials
export var REVIEWS_SUBMIT_REVIEW_EVENT_ACTION = 'Submit Review';
export var REVIEWS_OPEN_SUBMIT_REVIEW_MODAL_EVENT_ACTION = 'Open Submit Review Modal';

// Team
export var TEAM_VIEW_MEMBER_EVENT_ACTION = 'View Team Member';
export var TEAM_VIEW_ALL_MEMBERS_EVENT_ACTION = 'View All Team Members';
export var TEAM_MEMBER_INTERACTION_ACTION = 'Team Member Interaction';

// Blog
export var BLOG_VIEW_POST_EVENT_ACTION = 'View Blog Post';
export var BLOG_VIEW_ALL_POSTS_EVENT_ACTION = 'View All Blog Posts';
export var BLOG_SHARE_POST_EVENT_ACTION = 'Share Blog Post';

// Gallery
export var GALLERY_VIEW_IMAGE_EVENT_ACTION = 'View Image';
export var GALLERY_SEE_MORE_DIRECTION_EVENT_ACTION = 'See More';
export var GALLERY_USE_CONTROL_EVENT_ACTION = 'Use Control';

// Contact
export var CONTACT_SUBMIT_INQUIRY_EVENT_ACTION = 'Submit Inquiry';
export var CONTACT_FILL_FORM_EVENT_ACTION = 'Fill Form';
export var CONTACT_CALL_EVENT_ACTION = 'Call';
export var CONTACT_EMAIL_EVENT_ACTION = 'Email';

// Location
export var LOCATION_VIEW_LOCATION_EVENT_ACTION = 'View Location Details';
export var LOCATION_VIEW_LOCATION_ADDRESS_EVENT_ACTION = 'View Location Address';
export var LOCATION_TOGGLE_LOCATION_EVENT_ACTION = 'Toggle Location';
export var LOCATION_INTERACTION_ACTION = 'Location Interaction';

// Navigation
export var NAVIGATION_MENU_CLICK_EVENT_ACTION = 'Menu Click';
export var NAVIGATION_MENU_OPEN_EVENT_ACTION = 'Menu Open';

// Webchat
export var WEBCHAT_LINK_CLICK_EVENT_ACTION = 'Chat Link Click';

// FOOTER
export var FOOTER_SITEMAP_CLICK_EVENT_ACTION = 'Sitemap Click';

// Newsletter
export var NEWSLETTER_SIGNUP_EVENT_ACTION = 'Signup';

// Special Offers
export var SPECIAL_OFFERS_REDEEM_EVENT_ACTION = 'Redeem Offer';

// Social Media
export var SOCIAL_MEDIA_VIEW_EVENT_ACTION = 'View Social';

// Announcements
export var ANNOUNCEMENT_SEE_MORE_ACTION = 'See More';
export var ANNOUNCEMENT_BANNER_BUTTON_CLICK_ACTION = 'Banner CTA Click';
export var ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION = 'Modal CTA Click';

// Pagination
export var PAGINATION_INDICATOR_EVENT_ACTION = 'Indicator Click';
export var PAGINATION_ARROW_EVENT_ACTION = 'Arrow Click';
export var PAGINATION_PLAY_EVENT_ACTION = 'Play Click';
export var PAGINATION_PAUSE_EVENT_ACTION = 'Pause Click';

// Hours of operation
export var HOURS_OF_OPERATION_SHOW_EVENT_ACTION = 'Show Hours of Operation';

// Curated Hero
export var HERO_INTERACTION_ACTION = 'CTA Click';
export var EVENT_ACTIONS = {
  BOOKING_SCHEDULE_APPOINTMENT_EVENT_ACTION: BOOKING_SCHEDULE_APPOINTMENT_EVENT_ACTION,
  BOOKING_SCHEDULE_APPOINTMENT_INTENT_EVENT_ACTION: BOOKING_SCHEDULE_APPOINTMENT_INTENT_EVENT_ACTION,
  BOOKING_CANCEL_APPOINTMENT_EVENT_ACTION: BOOKING_CANCEL_APPOINTMENT_EVENT_ACTION,
  SERVICES_VIEW_CATEGORY_DETAILS_EVENT_ACTION: SERVICES_VIEW_CATEGORY_DETAILS_EVENT_ACTION,
  SERVICES_VIEW_ITEM_DETAILS_EVENT_ACTION: SERVICES_VIEW_ITEM_DETAILS_EVENT_ACTION,
  SERVICES_VIEW_ALL_SERVICES_EVENT_ACTION: SERVICES_VIEW_ALL_SERVICES_EVENT_ACTION,
  SERVICES_SHARE_ITEM_EVENT_ACTION: SERVICES_SHARE_ITEM_EVENT_ACTION,
  SERVICES_LIKE_ITEM_EVENT_ACTION: SERVICES_LIKE_ITEM_EVENT_ACTION,
  SERVICES_CATEGORY_INTERACTION_ACTION: SERVICES_CATEGORY_INTERACTION_ACTION,
  SERVICES_ITEM_INTERACTION_ACTION: SERVICES_ITEM_INTERACTION_ACTION,
  PRODUCTS_ADD_TO_CART_EVENT_ACTION: PRODUCTS_ADD_TO_CART_EVENT_ACTION,
  PRODUCTS_REMOVE_FROM_CART_EVENT_ACTION: PRODUCTS_REMOVE_FROM_CART_EVENT_ACTION,
  PRODUCTS_VIEW_PRODUCT_EVENT_ACTION: PRODUCTS_VIEW_PRODUCT_EVENT_ACTION,
  REVIEWS_SUBMIT_REVIEW_EVENT_ACTION: REVIEWS_SUBMIT_REVIEW_EVENT_ACTION,
  TEAM_VIEW_MEMBER_EVENT_ACTION: TEAM_VIEW_MEMBER_EVENT_ACTION,
  TEAM_VIEW_ALL_MEMBERS_EVENT_ACTION: TEAM_VIEW_ALL_MEMBERS_EVENT_ACTION,
  TEAM_MEMBER_INTERACTION_ACTION: TEAM_MEMBER_INTERACTION_ACTION,
  BLOG_VIEW_POST_EVENT_ACTION: BLOG_VIEW_POST_EVENT_ACTION,
  BLOG_VIEW_ALL_POSTS_EVENT_ACTION: BLOG_VIEW_ALL_POSTS_EVENT_ACTION,
  BLOG_SHARE_POST_EVENT_ACTION: BLOG_SHARE_POST_EVENT_ACTION,
  GALLERY_VIEW_IMAGE_EVENT_ACTION: GALLERY_VIEW_IMAGE_EVENT_ACTION,
  GALLERY_SEE_MORE_DIRECTION_EVENT_ACTION: GALLERY_SEE_MORE_DIRECTION_EVENT_ACTION,
  GALLERY_USE_CONTROL_EVENT_ACTION: GALLERY_USE_CONTROL_EVENT_ACTION,
  CONTACT_SUBMIT_INQUIRY_EVENT_ACTION: CONTACT_SUBMIT_INQUIRY_EVENT_ACTION,
  CONTACT_FILL_FORM_EVENT_ACTION: CONTACT_FILL_FORM_EVENT_ACTION,
  CONTACT_CALL_EVENT_ACTION: CONTACT_CALL_EVENT_ACTION,
  CONTACT_EMAIL_EVENT_ACTION: CONTACT_EMAIL_EVENT_ACTION,
  LOCATION_VIEW_LOCATION_EVENT_ACTION: LOCATION_VIEW_LOCATION_EVENT_ACTION,
  LOCATION_INTERACTION_ACTION: LOCATION_INTERACTION_ACTION,
  NAVIGATION_MENU_CLICK_EVENT_ACTION: NAVIGATION_MENU_CLICK_EVENT_ACTION,
  WEBCHAT_LINK_CLICK_EVENT_ACTION: WEBCHAT_LINK_CLICK_EVENT_ACTION,
  NAVIGATION_MENU_OPEN_EVENT_ACTION: NAVIGATION_MENU_OPEN_EVENT_ACTION,
  FOOTER_SITEMAP_CLICK_EVENT_ACTION: FOOTER_SITEMAP_CLICK_EVENT_ACTION,
  NEWSLETTER_SIGNUP_EVENT_ACTION: NEWSLETTER_SIGNUP_EVENT_ACTION,
  SPECIAL_OFFERS_REDEEM_EVENT_ACTION: SPECIAL_OFFERS_REDEEM_EVENT_ACTION,
  SOCIAL_MEDIA_VIEW_EVENT_ACTION: SOCIAL_MEDIA_VIEW_EVENT_ACTION,
  ANNOUNCEMENT_SEE_MORE_ACTION: ANNOUNCEMENT_SEE_MORE_ACTION,
  PAGINATION_INDICATOR_EVENT_ACTION: PAGINATION_INDICATOR_EVENT_ACTION,
  PAGINATION_ARROW_EVENT_ACTION: PAGINATION_ARROW_EVENT_ACTION,
  PAGINATION_PLAY_EVENT_ACTION: PAGINATION_PLAY_EVENT_ACTION,
  PAGINATION_PAUSE_EVENT_ACTION: PAGINATION_PAUSE_EVENT_ACTION,
  LOCATION_VIEW_LOCATION_ADDRESS_EVENT_ACTION: LOCATION_VIEW_LOCATION_ADDRESS_EVENT_ACTION,
  LOCATION_TOGGLE_LOCATION_EVENT_ACTION: LOCATION_TOGGLE_LOCATION_EVENT_ACTION,
  HOURS_OF_OPERATION_SHOW_EVENT_ACTION: HOURS_OF_OPERATION_SHOW_EVENT_ACTION,
  REVIEWS_OPEN_SUBMIT_REVIEW_MODAL_EVENT_ACTION: REVIEWS_OPEN_SUBMIT_REVIEW_MODAL_EVENT_ACTION,
  ANNOUNCEMENT_BANNER_BUTTON_CLICK_ACTION: ANNOUNCEMENT_BANNER_BUTTON_CLICK_ACTION,
  ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION: ANNOUNCEMENT_MODAL_BUTTON_CLICK_ACTION,
  HERO_INTERACTION_ACTION: HERO_INTERACTION_ACTION
};

/* Event Labels */
export var TEAM_MEMBER_LABEL = 'Team Member Page';
export var LOCATION_LABEL = 'Location Page';
export var EVENT_LABELS = {
  TEAM_MEMBER_LABEL: TEAM_MEMBER_LABEL,
  LOCATION_LABEL: LOCATION_LABEL
};